var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeWidth: 0.75,
    d: "M20.394 4.606l-.01-.412-.474-.018c-3.422-.126-8.044-2.546-8.936-3.03L10.705 1l-.268.147c-.886.484-5.48 2.906-8.943 3.03l-.473.017-.01.41c-.085 3.169.348 6.042 1.285 8.54.772 2.058 1.886 3.87 3.31 5.383 2.165 2.302 4.46 3.236 4.898 3.4L10.7 22l.197-.07c.435-.157 2.712-1.05 4.867-3.324 1.423-1.502 2.538-3.31 3.314-5.377.944-2.51 1.386-5.412 1.316-8.623z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#158CCC",
    strokeLinecap: "square",
    d: "M7.271 11.161l2.924 2.906M15.548 8.024l-5.116 5.81"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shieldIcon.928937d9ce16432631f5f7e6ca6f360f.svg";
export { ForwardRef as ReactComponent };